import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import * as sortabular from 'sortabular/dist';
import useDerivedStateFromProps from '@elliemae/ds-utilities/hooks/useDerivedStateFromProps';
import { checkIfSortable } from './checkIfSortable.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useSortableState(grid) {
  var _grid$props = grid.props,
      onSort = _grid$props.onSort,
      sortingColumnsProp = _grid$props.sortingColumns,
      pagination = _grid$props.pagination;

  var _useDerivedStateFromP = useDerivedStateFromProps(sortingColumnsProp),
      _useDerivedStateFromP2 = _slicedToArray(_useDerivedStateFromP, 2),
      sortingColumns = _useDerivedStateFromP2[0],
      setSortingColumns = _useDerivedStateFromP2[1];

  var handleSort = function handleSort(selectedColumn) {
    // support for pagination
    var _grid$getInstance = grid.getInstance(),
        _grid$getInstance$com = _grid$getInstance.composedRows,
        composedRows = _grid$getInstance$com === void 0 ? {} : _grid$getInstance$com,
        props = _grid$getInstance.props;

    var allRows = composedRows.allRows,
        rows = composedRows.rows;
    var serverSidePagination = pagination && composedRows.amount !== (composedRows.rows && composedRows.rows.length);

    if (props.serverSideData || serverSidePagination || checkIfSortable(selectedColumn, allRows || rows || composedRows)) {
      setSortingColumns(function (prevSortingColumns) {
        var nextSortingColumns = sortabular.byColumn({
          sortingColumns: prevSortingColumns,
          sortingOrder: {
            FIRST: 'asc',
            asc: 'desc',
            desc: 'asc'
          },
          selectedColumn: selectedColumn
        });

        var _grid$getInstance2 = grid.getInstance(),
            columns = _grid$getInstance2.columns;

        var columnSorted = columns.find(function (col) {
          return col.property === selectedColumn;
        });
        columnSorted = _objectSpread(_objectSpread({}, columnSorted), {}, {
          originalProperty: columnSorted.property
        });
        onSort(nextSortingColumns, selectedColumn, columnSorted);
        return nextSortingColumns;
      });
    }
  };

  return {
    state: {
      sortingColumns: sortingColumns
    },
    actions: {
      sort: handleSort
    }
  };
}

export { useSortableState };
//# sourceMappingURL=useSortableState.js.map
